import { IconButton, IconButtonProps, Tooltip } from '@mui/material'

interface SquareIconButtonProps extends IconButtonProps {
  tooltip?: string
  variant?: 'filled' | 'outlined'
}

const SquareIconButton: React.FC<SquareIconButtonProps> = ({ sx, tooltip, variant = 'filled', ...props }) => {
  const button = (
    <IconButton
      {...props}
      sx={{
        bgcolor: variant === 'filled' ? 'primary.main' : 'transparent',
        color: variant === 'filled' ? 'white' : 'inherit',
        borderRadius: 1,
        padding: 1,
        border: variant === 'outlined' ? '1px solid' : 'none',
        borderColor: variant === 'outlined' ? 'lightBorder' : 'transparent',
        '&:hover': {
          bgcolor: variant === 'filled' ? 'primary.dark' : 'action.hover',
        },
        ...sx,
      }}
    />
  )

  if (tooltip) {
    return <Tooltip title={tooltip}>{button}</Tooltip>
  }

  return button
}

export default SquareIconButton
